<template>
  <div class="container-fluid new_Header" v-if="!loader">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3">
              <router-link to="/">{{$t('myrents.breadcrumb_1')}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
              {{$t('myrents.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>  
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="text-center" v-if="hasError"> <errorAlert :alertMessage="message" :errorNumber="errorNumber" /> </div>

        <div v-if="loader" class="text-center">
          <mainloader />
        </div>

        <div v-else class="row pt-4">
          <div class="col-12 col-md-5 col-lg-4 mx-2 mb-3" v-for="(row,index) in rows" :key="index" >
            <router-link :to="'/rental/'+row.id">
              <div class="card card-border m-auto">
                <div class="card-body position-R">
                  <div class="row position-Abso pt-2">
                    <!-- <div class="col-auto tag-style me-3 pt-2">
                      <span class="">{{ row.PropertyType.name }}</span>
                    </div> -->
                    <div class="col-auto tag-style  pt-2">
                      <span>{{ value.statusChoices[row.status]}}</span>
                    </div>
                    <!-- <div class="col-auto tag-style me-1 pt-2">
                      <span class=""> {{(row.purpose == 'for_sale') ? 'للبيع' : 'للايجار'}} </span>
                    </div> -->
                  </div>
                  <!-- <span v-if="val.Favorites && val.Favorites.length" class="heart-icon-1" @click.prevent="removeFavorite(row.id, 'rows', index)">
                    <i  class="fa-solid fa-heart orange-Heart"></i>
                  </span>
                  <span v-else class="heart-icon-1" @click.prevent="addFavorite(row.id, 'rows', index)">
                    <i class="fa-solid fa-heart heart"></i>
                  </span> -->
                  <swiper v-if="row.mediaFiles.length" class="text-center" 
                    :autoplay="{ delay: 2500, disableOnInteraction: false,}" :modules="modules" 
                    :pagination="{ clickable: true }" :navigation="false"
                  >
                    <swiper-slide v-for="(img, ind) in row.mediaFiles" :key="ind">
                      <img :src="MEDIA_URL+img.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt="">
                  </div>
                  <div class="almarai-regular">{{ row.title }}</div>
                  <div class="d-flex pt-2">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="mx-2 gray-color fonttext-14">{{ row.City.name }}</div>
                    <div class="gray-color fonttext-14">{{ row.Neighborhood.name }}</div>
                  </div>
                  <hr class="border-color-w">
                  <div class="row space">
                    <div class="col-6 col-lg-6 button-center">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span class="green-color-F">{{ row.price }}</span>
                      <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                    </div>
                    <div class="col-6 col-lg-6">
                      <router-link to="/maintenances">
                        <div class="btn_light">{{$t('myrents.Maintenance_request')}}</div>
                      </router-link>
                    </div>
                    <!-- <div class="col-4">
                      <span>
                        <img :src="MEDIA_URL+value.countedIcons.bathrooms.path" class="img-fluid" alt="">
                      </span>
                      <span class="mx-1">{{ row.bathrooms }}</span>
                      <span class="mx-1">{{ value.countedIcons.bathrooms.name }}</span>
                    </div>
                    <div class="col-4 border-end">
                      <span>
                        <img :src="MEDIA_URL+value.countedIcons.roomsCount.path" class="img-fluid" alt="">
                      </span>
                      <span class="mx-1">{{ row.roomsCount }}</span>
                      <span class="mx-1">{{ value.countedIcons.roomsCount.name }}</span>
                    </div> -->
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="row" v-if="!loader && !rows.length">
          <div class="col">
            <div class="row">
              <div  class="col">
                <div class="text-center pb-3">
                  <img src="/assets/images/icons/Frame-48.png" class="img-fluid" alt="">
                </div>
                <div class="almarai-bold pt-2 text-center">انت لم تؤجر اي عقار</div>
                <div class="text-center almarai-regular gray-color fonttext-14">
                  <span>لا تخليه بخاطرك و ابدا في إيجار بيتك !</span>
                </div>
              </div>
            </div>
            <div class="row py-4 justify-content-center">
              <div class="col-6 text-center py-3">
                <router-link to="/">
                  <button class="submit-button form-control almarai-bold">تصفح عقارتنا</button>
                </router-link>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { mapGetters } from 'vuex';
export default {
  name: 'myrents',
  data(){
    return {
      hasError : false,
      errorNumber: 0,
      message: '',
      value: {},
      rows: [],
      loader: true,
      userLang: 'ar',
    }
  },

  components: { Swiper, SwiperSlide },

  setup() {
    return {
      modules: [Pagination, Navigation, Autoplay]
    };
  },

  computed: {
    ...mapGetters(['MEDIA_URL', 'GET_USER', 'ISLOADING'])
  },
  methods:{
    myRentals(){
      this.$http.get("/api/properties/rentals").then(res => {
        // console.log(res);
        this.value = res.data;
        this.rows = res.data.rows;
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        this.loader = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
  },

  created(){
    this.myRentals();
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>